import React from "react"
import PropTypes from "prop-types"
import { styled } from "@mui/material/styles"
import Rating from "@mui/material/Rating"
import Tooltip from "@mui/material/Tooltip"
import CheckIcon from "@mui/icons-material/CheckCircle"

const formatDate = (date) => {
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  }
  return new Date(date).toLocaleDateString("en-US", options)
}

const bluntSanitize = (text) => (text.includes("@") ? "" : text)

const StyledRating = styled(Rating)(({ theme }) => ({
  "& .MuiRating-iconFilled": {
    color: theme.palette.accentOne.main,
  },
}))

const ReviewV3 = ({ text, name, rating, location, date }) => (
  <div className="floating-box">
    {rating && (
      <div style={{ textAlign: "center" }}>
        <StyledRating value={rating} readOnly precision={0.5} />
      </div>
    )}
    <div className={`review-v3 ${text !== "" && "review-v3-has-text"}`}>
      {bluntSanitize(text)}
      <cite>
        <div
          style={{
            display: "flex",
            fontSize: 12,
            justifyContent: "center",
            alignItems: "center",
            marginTop: 10,
            color: "#555",
          }}
        >
          <Tooltip title="Verified Customer">
            <CheckIcon fontSize="small" />
          </Tooltip>
          <div style={{ paddingLeft: 4 }}>
            {bluntSanitize(name)}
            {location && <>, {location}</>}
            {date && <>, {formatDate(date)}</>}
          </div>
        </div>
      </cite>
    </div>
  </div>
)

ReviewV3.propTypes = {
  text: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  location: PropTypes.string,
  rating: PropTypes.number,
  date: PropTypes.number,
}

ReviewV3.defaultProps = {
  rating: null,
  location: null,
  date: null,
}

export default ReviewV3
